import { render, staticRenderFns } from "./ListRadioItem.vue?vue&type=template&id=68fae1f8&scoped=true&"
import script from "./ListRadioItem.vue?vue&type=script&lang=js&"
export * from "./ListRadioItem.vue?vue&type=script&lang=js&"
import style0 from "./ListRadioItem.vue?vue&type=style&index=0&id=68fae1f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fae1f8",
  null
  
)

export default component.exports